<template>
  <div id="add-new-order-modal">
    <!-- <v-layout row justify-center> -->
    <v-dialog v-model="sendToBranchModal" persistent max-width="650px">
      <v-card>
        <form action="" @submit.prevent="submitForm()">
          <v-card-title>
            <v-flex xs11 sm11 md11><span class="headline">{{ $t('datatable.sendToBranchButton') }}</span></v-flex>
            <v-flex xs1 sm1 md1>
              <v-btn flat @click="closeSendToBranchModal" class="close"><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="d-flex align-center">
                    <img
                      src="../../assets/images/whatsapp.png"
                      style="width: 32px; margin-top: -10px"
                      alt="whatsapp"
                      class="align-self-center mr-2"
                    >
                    <v-checkbox
                      style="padding: 0px;"
                      :label="$t('whatsappTemplate.sendWhatsappMessageLabel')"
                      v-model="sendToBranchData.send_sms"
                      color="indigo"
                    ></v-checkbox>
                  </div>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('columns.qrCode') + '*'"
                    v-model="sendToBranchData.order_id"
                    :error-messages="errors.collect('qrcode')"
                    v-validate="'required'"
                    data-vv-name="qrcode"
                    autofocus
                  />
                </v-flex>

                <v-flex xs12 v-if="sendToBranchData.send_sms" style="margin-top: 10px;">
                  <label
                    for="englishMessage"
                    style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                  >
                    {{ $t('whatsappTemplate.englishMessageLabel') }}
                  </label>
                  <textarea
                    v-model="sendToBranchData.englishMessage"
                    class="form-control"
                    style="border-bottom: 1px solid blue; font-size: 1.5rem; width: 50%; max-width: 100%; box-sizing: border-box;"
                    rows="4"
                  />
                </v-flex>
                <v-flex xs12 v-if="sendToBranchData.send_sms" style="margin-top: 10px;">
                  <label
                    for="arabicMessage"
                    style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                  >
                    {{ $t('whatsappTemplate.arabicMessageLabel') }}
                  </label>
                  <textarea
                    v-model="sendToBranchData.arabicMessage"
                    class="form-control"
                    style="border-bottom: 1px solid blue; font-size: 1.5rem; direction: rtl; width: 50%; max-width: 100%; box-sizing: border-box;"
                    rows="4"
                  />
                </v-flex>
                <v-flex xs12 v-if="sendToBranchData.send_sms" style="margin-top: 10px;">
                  <label
                    for="kurdishMessage"
                    style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                  >
                    {{ $t('whatsappTemplate.kurdishMessageLabel') }}
                  </label>
                  <textarea
                    v-model="sendToBranchData.kurdishMessage"
                    class="form-control"
                    style="border-bottom: 1px solid blue; font-size: 1.5rem; width: 50%; max-width: 100%; box-sizing: border-box;"
                    rows="4"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn class="buttonPadding" @click="saveTemplate" outline color="primary">{{ $t('whatsappTemplate.saveAsDefaultTemplateButton') }}</v-btn>
            <v-spacer></v-spacer>
            <div style="height:0px;overflow:hidden">
              <v-btn id="sendButton" type="submit" style="height:auto" outline color="success"
                >{{ $t('orders.sendTooltip') }}</v-btn
              >
            </div>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <!-- </v-layout> -->
  </div>
</template>
<script>
export default {
  props: ['sendToBranchModal', 'closeSendToBranchModal', 'sendToBranchData', 'sendToBranch', 'saveWhatsAppTemplate'],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.sendToBranch()
        }
      })
    },
    saveTemplate() {
      if (this.saveWhatsAppTemplate) {
        this.saveWhatsAppTemplate()
      }
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.input-group__details {
  min-height: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sendToBranch.vue